import { css } from '@emotion/core';
import { applyFont, tokens } from '@domain-group/fe-brary';
var colors = tokens.colors,
  spacing = tokens.spacing,
  typography = tokens.typography;
export var crossPromotion = /*#__PURE__*/css("max-width:1020px;margin:", spacing.l, " auto;border-top:1px solid ", colors.neutral.trim.default, ";padding-top:", spacing.l, ";");
export var heading = /*#__PURE__*/css("margin-bottom:", spacing.m, ";");
export var contentPanel = /*#__PURE__*/css("margin-top:", spacing.m, ";");
export var listingCard = {
  name: "10klw3m",
  styles: "height:100%;"
};
export var crossPromotedListingCard = {
  name: "vw6c3",
  styles: "flex-shrink:0;width:311px;padding:0 8px;&:first-child{padding-left:0;}&:last-child{padding-right:0;}"
};
export var listingCardCarousel = /*#__PURE__*/css("margin-bottom:", spacing.m, ";");
export var seeMoreLink = /*#__PURE__*/css("text-decoration:none;", applyFont(typography.body), " color:", colors.primary.base.default, ";");
export var loader = /*#__PURE__*/css("margin:", spacing.m, ";");